import { HeadLine } from '../../../layouts/headers/HeadLine'

export const CovidInfo = () => {
    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Información COVID-19' backurl='/hotel-info' />
            </div>
            <div className='w-full relative content-hi-sm'>
                <div className='p-2'>
                    <img className='m-auto' src="/assets/img/icons/covid-icon.svg" alt="icono codigo de conducta" />
                </div>

                <div className='mt-4'>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.
                    </p>
                    <br />
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.
                    </p>

                    <br />

                        <ul className='list-disc ml-5'>
                            <li>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.
                            </li>
                            <li>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.
                            </li>
                        </ul>
                </div>
            </div>
        </>
    )
}
